import React from 'react';
import { Shield, Lock, Users, History, Server, CheckCircle2 } from 'lucide-react';

const SECURITY_FEATURES = [
  {
    icon: Lock,
    title: 'Chiffrement de bout en bout',
    description: 'Vos données sont chiffrées en transit (TLS 1.3) et au repos (AES-256).'
  },
  {
    icon: Users,
    title: 'Contrôle d\'accès granulaire',
    description: 'Définissez précisément qui peut voir et modifier quoi, par projet et par rôle.'
  },
  {
    icon: History,
    title: 'Historique & audit complet',
    description: 'Chaque action est tracée. Consultez l\'historique complet à tout moment.'
  },
  {
    icon: Server,
    title: 'Infrastructure européenne',
    description: 'Hébergement en Europe (France). Conforme RGPD.'
  }
];

export function SecuritySection() {
  return (
    <section className="py-24 md:py-32 bg-slate-900 dark:bg-slate-950">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Left content */}
          <div>
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-emerald-500/10 text-emerald-400 text-sm font-medium mb-4">
              <Shield className="h-4 w-4" />
              Sécurité & Fiabilité
            </div>
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-6">
              Vos données sont
              <br />
              <span className="bg-gradient-to-r from-emerald-400 to-cyan-400 bg-clip-text text-transparent">
                entre de bonnes mains
              </span>
            </h2>
            <p className="text-lg text-slate-400 mb-8">
              La sécurité n'est pas une option. Lapyno est conçu dès le départ 
              pour protéger vos informations et garantir une disponibilité maximale.
            </p>

            {/* Stats */}
            <div className="grid grid-cols-3 gap-6">
              <div>
                <div className="text-3xl md:text-4xl font-bold text-white mb-1">99.9%</div>
                <div className="text-sm text-slate-400">Uptime garanti</div>
              </div>
              <div>
                <div className="text-3xl md:text-4xl font-bold text-white mb-1">RGPD</div>
                <div className="text-sm text-slate-400">Conforme</div>
              </div>
              <div>
                <div className="text-3xl md:text-4xl font-bold text-white mb-1">EU</div>
                <div className="text-sm text-slate-400">Hébergement</div>
              </div>
            </div>
          </div>

          {/* Right features */}
          <div className="grid gap-6">
            {SECURITY_FEATURES.map((feature) => {
              if (!feature?.icon) return null;
              const Icon = feature.icon;
              return (
                <div
                  key={feature.title}
                  className="flex gap-4 p-5 rounded-xl bg-slate-800/50 border border-slate-700/50 hover:border-emerald-500/30 transition-colors"
                >
                  <div className="p-2 h-fit rounded-lg bg-emerald-500/10">
                    <Icon className="h-5 w-5 text-emerald-400" />
                  </div>
                  <div>
                    <h3 className="font-semibold text-white mb-1">{feature.title}</h3>
                    <p className="text-sm text-slate-400">{feature.description}</p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
